var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHasMembership = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.41667 16.6666c1.61083 0 2.91666-1.3058 2.91666-2.9166 0-1.6109-1.30583-2.9167-2.91666-2.9167s-2.91667 1.3058-2.91667 2.9167c0 1.6108 1.30584 2.9166 2.91667 2.9166z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.86076 9.16665c1.61084 0 2.91664-1.30584 2.91664-2.91667s-1.3058-2.91667-2.91664-2.91667c-1.61083 0-2.91667 1.30584-2.91667 2.91667s1.30584 2.91667 2.91667 2.91667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.3058 16.6666c1.6109 0 2.9167-1.3058 2.9167-2.9166 0-1.6109-1.3058-2.9167-2.9167-2.9167-1.6108 0-2.9166 1.3058-2.9166 2.9167 0 1.6108 1.3058 2.9166 2.9166 2.9166z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHasMembership);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/has-membership.2478a7584d5ad8a16578f78117efb01b.svg";